export const DiccionarioAcademico_EN = [
    {
        'codigo': 'CodeRequeridoBuildingFloorId',
        'mensaje': 'The floor is required'
    },
    {
        'codigo': 'CodeRequeridoCampusId',
        'mensaje': 'Campus is required'
    },
    {
        'codigo': 'CodeRequeridoProgramId',
        'mensaje': 'Program is required'
    },
    {
        'codigo': 'CodeRequeridoCapacity',
        'mensaje': 'Capacity is required'
    },
    {
        'codigo': 'CodeRequeridoBuildingId',
        'mensaje': 'The building is required'
    },
    {
        'codigo': 'CodeRequeridoClassroomTypeId',
        'mensaje': 'The type of classroom is required'
    },
    {
        'codigo': 'CodeRequeridoCourseId',
        'mensaje': 'The course is required'
    },
    {
        'codigo': 'CodeRequeridoFechaAprovado',
        'mensaje': 'Approval date is required'
    },
    {
        'codigo': 'CodeRequeridoPeriodDetailId',
        'mensaje': 'You must select a detail of the academic period'
    },
    {
        'codigo': 'CodeRequeridoPeriodId',
        'mensaje': 'The academic period is required'
    },
    {
        'codigo': 'CodeRequeridoWeekdays',
        'mensaje': 'The day is required'
    },
    {
        'codigo': 'ErrorCompararFecha',
        'mensaje': 'The start date must not be greater than the end date'
    },
    {
        'codigo': 'ErrorCrearUnEvento',
        'mensaje': 'You should at least create a schedule to continue'
    },
    {
        'codigo': 'ErrorSelecUnPrograma',
        'mensaje': 'At least one select a course and academic program'
    },
    {
        'codigo': 'ErrorTipoCIFNotEmty',
        'mensaje': 'You must select a type of CIF'
    },
    {
        'codigo': 'ErrorValidDateFormat',
        'mensaje': 'You must enter a valid date'
    },
    {
        'codigo': 'warningSedePrograma',
        'mensaje': 'The admission campus was not found, check the user permissions and the academic program campus'
    },
    {
        'codigo': 'WarningSelectBlock',
        'mensaje': 'You must select a block for the admission requirement'
    },
    {
        'codigo': 'WarningSelectCalificacion',
        'mensaje': 'You must select a classification'
    },
    {
        'codigo': 'WarningSelectCareerCode',
        'mensaje': 'The career code is required'
    },
    {
        'codigo': 'WarningSelectCarrera',
        'mensaje': 'The career is required'
    },
    {
        'codigo': 'WarningSelectCourse',
        'mensaje': 'The course is required'
    },
    {
        'codigo': 'WarningSelectEstudiante',
        'mensaje': 'You must select a student'
    },
    {
        'codigo': 'WarningSelectGradeCode',
        'mensaje': 'You must select an academic degree'
    },
    {
        'codigo': 'WarningSelectGrado',
        'mensaje': 'You must select an academic degree'
    },
    {
        'codigo': 'WarningSelectJornada',
        'mensaje': 'You must select a schedule type'
    },
    {
        'codigo': 'WarningSelectModalidad',
        'mensaje': 'You must select a modality'
    },
    {
        'codigo': 'WarningSelectPais',
        'mensaje': 'You must select a country'
    },
    {
        'codigo': 'WarningSelectPrograma',
        'mensaje': 'You must select an academic program'
    },
    {
        'codigo': 'WarningSelectRequirement',
        'mensaje': 'You must select a requirement'
    },
    {
        'codigo': 'WarningSelectSede',
        'mensaje': 'You must select a campus'
    },
    {
        'codigo': 'WarningSelectTipoOferta',
        'mensaje': 'You must select the type of academic offer'
    },
    {
        'codigo': 'WarningSelectTipoPeriodo',
        'mensaje': 'You must select the type of period'
    },
    {
        'codigo': 'WarningSubPeriod',
        'mensaje': 'You must enter the subperiod number'
    },
    {
        'codigo': 'ErrorActualizarAdmisionSede',
        'mensaje': 'There were problems updating the admission campus'
    },
    {
        'codigo': 'ErrorActualizarAsistencia',
        'mensaje': 'Problems occurred updating student attendance'
    },
    {
        'codigo': 'ErrorActualizarInstructor',
        'mensaje': 'There were problems updating the instructor'
    },
    {
        'codigo': 'ErrorActualizarSedesDetalle',
        'mensaje': 'There were problems updating the campus'
    },
    {
        'codigo': 'ErrorAnnotationIdNotEmpty',
        'mensaje': 'Annotation data not found'
    },
    {
        'codigo': 'ErrorAnnotationNotEmpty',
        'mensaje': 'You must enter an annotation'
    },
    {
        'codigo': 'ErrorAnnotationTypeIdNotEmpty',
        'mensaje': 'You must select the type of annotation'
    },
    {
        'codigo': 'ErrorCommentNotEmpty',
        'mensaje': 'You must enter a comment'
    },
    {
        'codigo': 'ErrorCreateRequisitoAdminision',
        'mensaje': 'There were problems creating the admission requirement'
    },
    {
        'codigo': 'ErrorCreateRequisitoGraduacion',
        'mensaje': 'There were problems creating the graduation requirement'
    },
    {
        'codigo': 'ErrorDeleteAcaProgram',
        'mensaje': 'Problems occurred when deleting the academic program'
    },
    {
        'codigo': 'ErrorDeleteAcaProgramDetails',
        'mensaje': 'There were problems when removing the detail of the academic program'
    },
    {
        'codigo': 'ErrorDeleteAdmission',
        'mensaje': 'Problems occurred removing admission'
    },
    {
        'codigo': 'ErrorDeleteAnnotation',
        'mensaje': 'There were problems removing the annotation'
    },
    {
        'codigo': 'ErrorDeleteAttachRequirements',
        'mensaje': 'There were problems deleting the attached document'
    },
    {
        'codigo': 'ErrorDeleteAula',
        'mensaje': 'There were problems deleting the classroom'
    },
    {
        'codigo': 'ErrorDeleteCareer',
        'mensaje': 'Problems occurred when deleting the career'
    },
    {
        'codigo': 'ErrorDeleteClient',
        'mensaje': 'There were problems removing the customer'
    },
    {
        'codigo': 'ErrorDeleteClientContries',
        'mensaje': 'Problems arose when removing nationality'
    },
    {
        'codigo': 'ErrorDeleteClientWorkplace',
        'mensaje': 'There were problems deleting employment information'
    },
    {
        'codigo': 'ErrorDeleteCourse',
        'mensaje': 'There were problems deleting the course'
    },
    {
        'codigo': 'ErrorDeleteCurriculumCourse',
        'mensaje': 'There were problems deleting the resume'
    },
    {
        'codigo': 'ErrorDeleteCustomerAddress',
        'mensaje': 'There were problems removing the address'
    },
    {
        'codigo': 'ErrorDeleteCustomerContacts',
        'mensaje': 'There were problems deleting the contact'
    },
    {
        'codigo': 'ErrorDeleteCustomerEmail',
        'mensaje': 'Problems occurred deleting email'
    },
    {
        'codigo': 'ErrorDeleteCustomerLanguaje',
        'mensaje': 'There were problems removing the language'
    },
    {
        'codigo': 'ErrorDeleteCustomerProfiles',
        'mensaje': 'There were problems when removing the type of CIF'
    },
    {
        'codigo': 'ErrorDeleteFileAnnotation',
        'mensaje': 'There were problems deleting the attachment'
    },
    {
        'codigo': 'ErrorDeleteHorario',
        'mensaje': 'There were problems deleting the schedule'
    },
    {
        'codigo': 'ErrorDeleteInstructor',
        'mensaje': 'There were problems removing the instructor'
    },
    {
        'codigo': 'ErrorDeleteOfertaAcademica',
        'mensaje': 'There were problems removing the academic offer'
    },
    {
        'codigo': 'ErrorDeletePeriodoDetalle',
        'mensaje': 'There were problems when removing the detail of the academic period'
    },
    {
        'codigo': 'ErrorDeletePeriodosAca',
        'mensaje': 'Problems arose when deleting the academic period'
    },
    {
        'codigo': 'ErrorDeleteProgramCourseGrouping',
        'mensaje': 'There were problems deleting the course'
    },
    {
        'codigo': 'ErrorDeleteRequisitoAdminision',
        'mensaje': 'There were problems removing the admission requirement'
    },
    {
        'codigo': 'ErrorDeleteRequisitoCurso',
        'mensaje': 'There were problems removing the course requirement'
    },
    {
        'codigo': 'ErrorDeleteRequisitoGraduacion',
        'mensaje': 'Issues encountered removing graduation requirement'
    },
    {
        'codigo': 'ErrorEnrollChangeAcaOffer',
        'mensaje': 'There were problems when making the course change'
    },
    {
        'codigo': 'ErrorEstudiantesAsistencia',
        'mensaje': 'There were problems getting student attendance'
    },
    {
        'codigo': 'ErrorFavoriteCustomerAddress',
        'mensaje': 'There were problems getting directionss'
    },
    {
        'codigo': 'ErrorFavoriteCustomerContacts',
        'mensaje': 'There were problems getting contacts'
    },
    {
        'codigo': 'ErrorGetAcaProgram',
        'mensaje': 'There were problems obtaining the program detail'
    },
    {
        'codigo': 'ErrorGetAdmission',
        'mensaje': 'There were problems obtaining the admission detail'
    },
    {
        'codigo': 'ErrorGetAula',
        'mensaje': 'Problems arose when obtaining the classroom detail'
    },
    {
        'codigo': 'ErrorGetCareer',
        'mensaje': 'There were problems when obtaining the detail of the career'
    },
    {
        'codigo': 'ErrorGetClientContries',
        'mensaje': 'There were problems obtaining the countries'
    },
    {
        'codigo': 'ErrorGetCourse',
        'mensaje': 'There were problems obtaining the details of the course'
    },
    {
        'codigo': 'ErrorGetJornadaProgramAca',
        'mensaje': 'There were problems obtaining the details of the schedule'
    },
    {
        'codigo': 'ErrorGetListAttachRequirements',
        'mensaje': 'There were problems getting the list of attachments from the requirements'
    },
    {
        'codigo': 'ErrorGetListClientWorkplace',
        'mensaje': 'There were problems obtaining employment information'
    },
    {
        'codigo': 'ErrorGetOfertaAcademica',
        'mensaje': 'Problems arose when obtaining the details of the academic offer'
    },
    {
        'codigo': 'ErrorGetPeriodosAca',
        'mensaje': 'Problems arose when obtaining academic periods'
    },
    {
        'codigo': 'ErrorGetProgramBlocks',
        'mensaje': 'There were problems obtaining the blocks of the academic program'
    },
    {
        'codigo': 'ErrorGetStudentAcaOffer',
        'mensaje': 'There were problems getting students enrolled'
    },
    {
        'codigo': 'ErrorInsertAnnotation',
        'mensaje': 'There were problems registering the annotation'
    },
    {
        'codigo': 'ErrorInsertAttachRequirements',
        'mensaje': 'There were problems uploading the attached document'
    },
    {
        'codigo': 'ErrorInsertFileAnnotation',
        'mensaje': 'There were problems uploading the attached document'
    },
    {
        'codigo': 'ErrorInsertRequisitoCurso',
        'mensaje': 'Problems occurred registering the course requirement'
    },
    {
        'codigo': 'ErrorInstructorIdNotEmty',
        'mensaje': 'Instructor information not found'
    },
    {
        'codigo': 'ErrorLessonDateNotEmpty',
        'mensaje': 'You must indicate the date of the lesson'
    },
    {
        'codigo': 'ErrorListAcaAula',
        'mensaje': 'There were problems getting the list of classrooms'
    },
    {
        'codigo': 'ErrorListAcaProgramDetails',
        'mensaje': 'Problems arose when obtaining the details of the academic program'
    },
    {
        'codigo': 'ErrorListAcaRecursos',
        'mensaje': 'There were problems getting the list of resources'
    },
    {
        'codigo': 'ErrorListAdmisionSede',
        'mensaje': 'There were problems obtaining the list of campus for admission'
    },
    {
        'codigo': 'ErrorListaEstudiantesOfertaAcademica',
        'mensaje': 'There were problems getting students enrolled'
    },
    {
        'codigo': 'ErrorListAnnotation',
        'mensaje': 'There were problems getting the list of annotations'
    },
    {
        'codigo': 'ErrorListaRubrosCalificacion',
        'mensaje': 'There were problems obtaining the list of qualification items'
    },
    {
        'codigo': 'ErrorListAulas',
        'mensaje': 'There were problems getting the list of classrooms'
    },
    {
        'codigo': 'ErrorListAulasDisponibles',
        'mensaje': 'There were problems getting the list of available classrooms'
    },
    {
        'codigo': 'ErrorListAulasSugeridas',
        'mensaje': 'There were problems getting the list of suggested classrooms'
    },
    {
        'codigo': 'ErrorListCorrequisitosCursos',
        'mensaje': 'There were problems getting the list of corequisites courses'
    },
    {
        'codigo': 'ErrorListCurriculumCourse',
        'mensaje': 'There were problems obtaining the list of curricular courses'
    },
    {
        'codigo': 'ErrorListCursosEstudiantes',
        'mensaje': 'Failed to get student course listing'
    },
    {
        'codigo': 'ErrorListCursosHorarios',
        'mensaje': 'Problems arose when obtaining the list of schedules of the courses of the academic offer'
    },
    {
        'codigo': 'ErrorListCursosOfertaAcademica',
        'mensaje': 'Problems arose when obtaining the list of courses from the academic offer'
    },
    {
        'codigo': 'ErrorListCursosOfertados',
        'mensaje': 'There were problems obtaining the list of courses offered'
    },
    {
        'codigo': 'ErrorListCursosRecurso',
        'mensaje': 'There were problems getting course resources'
    },
    {
        'codigo': 'ErrorListCustomerAddress',
        'mensaje': 'Problems getting directions'
    },
    {
        'codigo': 'ErrorListCustomerContacts',
        'mensaje': 'Had problems getting contacts'
    },
    {
        'codigo': 'ErrorListCustomerEmail',
        'mensaje': 'There were problems getting emails'
    },
    {
        'codigo': 'ErrorListCustomerLanguaje',
        'mensaje': 'There were problems getting the languages'
    },
    {
        'codigo': 'ErrorListCustomerProfiles',
        'mensaje': 'Problems arose when obtaining the types of CIF'
    },
    {
        'codigo': 'ErrorListDetalleJornada',
        'mensaje': 'There were problems obtaining the details of the day'
    },
    {
        'codigo': 'ErrorListDetalles',
        'mensaje': 'There were problems getting the list of details'
    },
    {
        'codigo': 'ErrorListFormatFile',
        'mensaje': 'There were problems getting the list of file formats'
    },
    {
        'codigo': 'ErrorListGruposOfertados',
        'mensaje': 'Problems arose when obtaining the list of offered groups'
    },
    {
        'codigo': 'ErrorListHorarios',
        'mensaje': 'There were problems getting the schedule list'
    },
    {
        'codigo': 'ErrorListInstructoresAsignado',
        'mensaje': 'There were problems getting assigned instructors'
    },
    {
        'codigo': 'ErrorListInstructoresDisponibles',
        'mensaje': 'There were problems getting available instructors'
    },
    {
        'codigo': 'ErrorListInstructoresSugeridos',
        'mensaje': 'There were problems getting suggested instructors'
    },
    {
        'codigo': 'ErrorListOfertaAcademica',
        'mensaje': 'There were problems obtaining academic offers'
    },
    {
        'codigo': 'ErrorListOfertaAcademicaPractica',
        'mensaje': 'Problems arose when obtaining available academic offers for practical/lab classes'
    },
    {
        'codigo': 'ErrorListProgramaCursosRecurso',
        'mensaje': 'There were problems obtaining the list of program resources by course'
    },
    {
        'codigo': 'ErrorListProgramCourseGrouping',
        'mensaje': 'There were problems obtaining the list of groupings of the program course'
    },
    {
        'codigo': 'ErrorListProgramCourseGroupingRequirement',
        'mensaje': 'There were problems obtaining the list of requirements of the groupings of the program course'
    },
    {
        'codigo': 'ErrorListRequisitoAdminision',
        'mensaje': 'There were problems obtaining the list of admission requirements for the program'
    },
    {
        'codigo': 'ErrorListRequisitoCurso',
        'mensaje': 'There were problems obtaining the list of course requirements'
    },
    {
        'codigo': 'ErrorListRequisitoCursoVin',
        'mensaje': 'There were problems obtaining the course list linked to the program'
    },
    {
        'codigo': 'ErrorListRequisitosCursos',
        'mensaje': 'There were problems obtaining the list of course requirements'
    },
    {
        'codigo': 'ErrorListSedesDetalles',
        'mensaje': 'Failed to get campus list'
    },
    {
        'codigo': 'ErrorListSedesPrograma',
        'mensaje': 'Problems arose when obtaining the list of program campus'
    },
    {
        'codigo': 'ErrorListSedesVinculadasPrograma',
        'mensaje': 'Problems arose when obtaining the list of linked campus of the program'
    },
    {
        'codigo': 'ErrorListSemanasOfertaAcademica',
        'mensaje': 'There were problems obtaining the weeks of the academic offer'
    },
    {
        'codigo': 'ErrorRequisitoAdminisionByID',
        'mensaje': 'There were problems obtaining the admission requirements'
    },
    {
        'codigo': 'ErrorRetirarCursoEst',
        'mensaje': 'Problems arose during the process of withdrawing from the course'
    },
    {
        'codigo': 'ErrorSaveAcaProgram',
        'mensaje': 'There were problems saving the information of the academic program'
    },
    {
        'codigo': 'ErrorSaveAula',
        'mensaje': 'There were problems saving classroom information'
    },
    {
        'codigo': 'ErrorSaveCareer',
        'mensaje': 'There were problems saving carrer information'
    },
    {
        'codigo': 'ErrorSaveClient',
        'mensaje': 'There were problems saving customer information'
    },
    {
        'codigo': 'ErrorSaveClientContries',
        'mensaje': 'There were problems saving the nationality information'
    },
    {
        'codigo': 'ErrorSaveClientWorkplace',
        'mensaje': 'There were problems saving the information of the work information'
    },
    {
        'codigo': 'ErrorSaveCourse',
        'mensaje': 'There were problems saving course information'
    },
    {
        'codigo': 'ErrorSaveCurriculumCourse',
        'mensaje': 'There were problems saving the resume information'
    },
    {
        'codigo': 'ErrorSaveCustomerAddress',
        'mensaje': 'Problems occurred saving address information'
    },
    {
        'codigo': 'ErrorSaveCustomerContacts',
        'mensaje': 'There were problems saving contact information'
    },
    {
        'codigo': 'ErrorSaveCustomerEmail',
        'mensaje': 'Problems occurred saving email information'
    },
    {
        'codigo': 'ErrorSaveCustomerLanguaje',
        'mensaje': 'There were problems saving the language information'
    },
    {
        'codigo': 'ErrorSaveCustomerProfiles',
        'mensaje': 'There were problems when saving the information of the type of CIF'
    },
    {
        'codigo': 'ErrorSaveHorario',
        'mensaje': 'There were problems saving schedule information'
    },
    {
        'codigo': 'ErrorSaveInstructor',
        'mensaje': 'Problems occurred when saving instructor information'
    },
    {
        'codigo': 'ErrorSaveOfertaAcademica',
        'mensaje': 'There were problems saving the information of the academic offer'
    },
    {
        'codigo': 'ErrorSavePeriodoDetalle',
        'mensaje': 'Problems were presented when saving the information of the detail of the academic period'
    },
    {
        'codigo': 'ErrorSavePeriodosAca',
        'mensaje': 'There were problems saving the information of the academic period'
    },
    {
        'codigo': 'ErrorUpdateAcaProgram',
        'mensaje': 'There were problems saving the information of the academic program'
    },
    {
        'codigo': 'ErrorUpdateAcaProgramDetails',
        'mensaje': 'There were problems saving the course information of the academic program'
    },
    {
        'codigo': 'ErrorUpdateAdmission',
        'mensaje': 'There were problems saving admission information'
    },
    {
        'codigo': 'ErrorUpdateAnnotation',
        'mensaje': 'Problems occurred when saving annotation information'
    },
    {
        'codigo': 'ErrorUpdateAula',
        'mensaje': 'There were problems saving classroom information'
    },
    {
        'codigo': 'ErrorUpdateCareer',
        'mensaje': 'There were problems saving career information'
    },
    {
        'codigo': 'ErrorUpdateClient',
        'mensaje': 'There were problems saving customer information'
    },
    {
        'codigo': 'ErrorUpdateClientWorkplace',
        'mensaje': 'Problems occurred saving workplace information'
    },
    {
        'codigo': 'ErrorUpdateCourse',
        'mensaje': 'There were problems saving course information'
    },
    {
        'codigo': 'ErrorUpdateCurriculumCourse',
        'mensaje': 'There were problems saving the resume information'
    },
    {
        'codigo': 'ErrorUpdateCursosOfertaAcademica',
        'mensaje': 'There were problems saving the course of the academic offer'
    },
    {
        'codigo': 'ErrorUpdateCursosRecursos',
        'mensaje': 'There were problems saving course resources'
    },
    {
        'codigo': 'ErrorUpdateCustomerAddress',
        'mensaje': 'Problems occurred saving address information'
    },
    {
        'codigo': 'ErrorUpdateCustomerContacts',
        'mensaje': 'There were problems saving contact information'
    },
    {
        'codigo': 'ErrorUpdateCustomerEmail',
        'mensaje': 'Problems occurred saving email information'
    },
    {
        'codigo': 'ErrorUpdateCustomerLanguaje',
        'mensaje': 'There were problems saving the language information'
    },
    {
        'codigo': 'ErrorUpdateDetailsCustomerLanguaje',
        'mensaje': 'There were problems saving the language detail information'
    },
    {
        'codigo': 'ErrorUpdateDetalleJornada',
        'mensaje': 'There were problems when saving the information of the detail of the day'
    },
    {
        'codigo': 'ErrorUpdateFormatFile',
        'mensaje': 'There were problems saving the information of the file formats'
    },
    {
        'codigo': 'ErrorUpdateHorario',
        'mensaje': 'There were problems saving schedule information'
    },
    {
        'codigo': 'ErrorUpdateOfertaAcademica',
        'mensaje': 'There were problems saving the information of the academic offer'
    },
    {
        'codigo': 'ErrorUpdatePeriodoDetalle',
        'mensaje': 'Problems were presented when saving the information of the detail of the academic period'
    },
    {
        'codigo': 'ErrorUpdatePeriodosAca',
        'mensaje': 'There were problems saving the information of the academic period'
    },
    {
        'codigo': 'ErrorUpdateProgramaCursosRecursos',
        'mensaje': 'There were problems saving course information from the program'
    },
    {
        'codigo': 'ErrorUpdateProgramCourseGrouping',
        'mensaje': 'There were problems saving course information from the program'
    },
    {
        'codigo': 'ErrorUpdateProgramCourseGroupingRequirement',
        'mensaje': 'Problems occurred saving course requirements information'
    },
    {
        'codigo': 'ErrorUpdateRecursos',
        'mensaje': 'There were problems saving resource information'
    },
    {
        'codigo': 'ErrorUpdateRequisitoAdminision',
        'mensaje': 'There were problems saving the admission requirement information'
    },
    {
        'codigo': 'ErrorUpdateRequisitoCurso',
        'mensaje': 'Problems occurred saving course requirement information'
    },
    {
        'codigo': 'ErrorUpdateRequisitoGraduacion',
        'mensaje': 'Problems occurred saving graduation requirement information'
    },
    {
        'codigo': 'ErrorUpdateSedes',
        'mensaje': 'There were problems saving the campus information'
    },
    {
        'codigo': 'ErrorUpdateSedesPrograma',
        'mensaje': 'There were problems saving the information of the program campus'
    },
    {
        'codigo': 'ErrorValidarSedesDetalle',
        'mensaje': 'The campus is already linked to another detail of the same period'
    },
    {
        'codigo': 'ErrorValidatingAcaProgram',
        'mensaje': 'Problems arose when validating the academic program'
    },
    {
        'codigo': 'ErrorValidatingAdmission',
        'mensaje': 'The student already has an admission for this academic program'
    },
    {
        'codigo': 'ErrorValidatingAula',
        'mensaje': 'There is already another classroom with the same code'
    },
    {
        'codigo': 'ErrorValidatingAulas',
        'mensaje': 'The classroom is already assigned to the schedule'
    },
    {
        'codigo': 'ErrorValidatingCareer',
        'mensaje': 'There were problems validating the race data'
    },
    {
        'codigo': 'ErrorValidatingCountryClient',
        'mensaje': 'The country information could not be validated'
    },
    {
        'codigo': 'ErrorValidatingCourse',
        'mensaje': 'There were problems validating course data'
    },
    {
        'codigo': 'ErrorValidatingCursosOfertaAcademica',
        'mensaje': 'Problems arose when validating the course of the academic offer'
    },
    {
        'codigo': 'ErrorValidatingCustomerEmail',
        'mensaje': 'There were problems validating the email'
    },
    {
        'codigo': 'ErrorValidatingCustomerLanguaje',
        'mensaje': 'There were problems validating the language'
    },
    {
        'codigo': 'ErrorValidatingFechasCambiarCurso',
        'mensaje': 'There were problems validating the dates for course changes'
    },
    {
        'codigo': 'ErrorValidatingFechasInscripcion',
        'mensaje': 'There were problems validating course enrollment dates'
    },
    {
        'codigo': 'ErrorValidatingFechasRetirarCurso',
        'mensaje': 'Problems arose when validating the dates for course withdrawal'
    },
    {
        'codigo': 'ErrorValidatingHorarios',
        'mensaje': 'Problems arose when validating the academic schedule'
    },
    {
        'codigo': 'ErrorChoqueHorariosOft',
        'mensaje': 'Unable to process registration due to schedule clashes'
    },
    {
        'codigo': 'ErrorRangoHorariosOft',
        'mensaje': 'The registration cannot be processed because it is outside the range of the schedule'
    },
    {
        'codigo': 'ErrorValidatingInstructor',
        'mensaje': 'Problems arose when validating the instructor associated with the academic offer'
    },
    {
        'codigo': 'ErrorGrupoOfertaAcademica',
        'mensaje': 'The entered group number already exists for another academic offer'
    },
    {
        'codigo': 'ErrorSchedulesOfertaAcademica',
        'mensaje': 'You cannot change the schedule because the academic offer have different hours or days of the week'
    },
    {
        'codigo': 'ErrorValidatingPeriodosAca',
        'mensaje': 'Problems arose when validating the academic period'
    },
    {
        'codigo': 'ErrorValidatingProgramCourseGrouping',
        'mensaje': 'Problems arose when validating the course grouping of the academic program'
    },
    {
        'codigo': 'ErrorValidatingProgramDetails',
        'mensaje': 'There were problems validating the details of the academic program'
    },
    {
        'codigo': 'ErrorValidatingRequisitoAdminision',
        'mensaje': 'There were problems validating the admission requirement of the program'
    },
    {
        'codigo': 'ErrorValidatingRequisitoCurso',
        'mensaje': 'There were problems validating the program course requirement'
    },
    {
        'codigo': 'ErrorVisualizationNotEmpty',
        'mensaje': 'You must indicate the display type of the student annotation'
    },
    {
        'codigo': 'ErrorExistsCustomerEmail',
        'mensaje': 'The email is already registered'
    },
    {
        'codigo': 'DuplicateCustomerEmail',
        'mensaje': 'The email is already linked to another customer'
    },
    {
        'codigo': 'ErrorAcaPeriodDuplicate',
        'mensaje': 'The entered academic period already exists'
    },
    {
        'codigo': 'ErrorAcaSubPeriodDuplicate',
        'mensaje': 'The entered academic subperiod already exists'
    },
    {
        'codigo': 'ErrorCourseAlreadyApp',
        'mensaje': 'The selected course is already approved'
    },
    {
        'codigo': 'ErrorCourseAlreadyEnroll',
        'mensaje': 'The selected course is already registered'
    },
    {
        'codigo': 'ErrorCourseRequirements',
        'mensaje': 'The selected course has pending requirements'
    },
    {
        'codigo': 'ErrorCustomerUniqueProfile',
        'mensaje': 'The record cannot be deleted, it must have at least one type of CIF'
    },
    {
        'codigo': 'ErrorProgramAcaBlock',
        'mensaje': 'The block must be consecutive'
    },
    {
        'codigo': 'ErrorProgramAcaBlock0',
        'mensaje': 'Block must not be 0'
    },
    {
        'codigo': 'ErrorProgramAcaCurseAliasDupl',
        'mensaje': 'That alias already exists for a course in the academic program'
    },
    {
        'codigo': 'ErrorProgramAcaCurseDuplicate',
        'mensaje': 'The course already exists in the academic program'
    },
    {
        'codigo': 'ErrorProgramAcaSeqDuplicate',
        'mensaje': 'This sequence already exists for a course of the academic program'
    },
    {
        'codigo': 'ErrorProgramAcaSequence',
        'mensaje': 'The sequence must be consecutive'
    },
    {
        'codigo': 'ErrorProgramAcaSequence0',
        'mensaje': 'The sequence must not be 0'
    },
    {
        'codigo': 'ErrorScheduleConflict',
        'mensaje': 'There were clash of schedules, check the information'
    },
    {
        'codigo': 'InstructorNotAvailable',
        'mensaje': 'The instructor is no longer available for the selected schedule'
    },
    {
        'codigo': 'InstructorPrincipal',
        'mensaje': 'There can only be one principal instructor per schedule, check the information'
    },
    {
        'codigo': 'PeriodDateNotAvailable',
        'mensaje': 'There are no available dates of the academic period for the campus'
    },
    {
        'codigo': 'CourseEnrolledOk',
        'mensaje': 'The course has been enrolled'
    },
    {
        'codigo': 'CourseUnenrolledOk',
        'mensaje': 'The course has been unenrolled'
    },
    {
        'codigo': 'SeleccioneCurso',
        'mensaje': 'You must select a course'
    },
    {
        'codigo': 'CursoRetirado',
        'mensaje': 'The course has been withdrawn'
    },
    {
        'codigo': 'CursoCambiado',
        'mensaje': 'The course change has been made'
    },
    {
        'codigo': 'EvaStrExistCode',
        'mensaje': 'An item with that code already exists!'
    },
    {
        'codigo': 'EvaStrReqFormula',
        'mensaje': 'You must enter a formula to calculate the item'
    },
    {
        'codigo': 'EvaStrDeleteFormula',
        'mensaje': 'The item belongs to a formula, validate the formulas of the other items'
    },
    {
        'codigo': 'EvaStrValMinimo',
        'mensaje': 'You must enter the minimum value'
    },
    {
        'codigo': 'EvaStrValMaximo',
        'mensaje': 'You must enter the maximum value'
    },
    {
        'codigo': 'EvaStrExistNotaFinal',
        'mensaje': 'There can only be one final grade item'
    },
    {
        'codigo': 'EvaStrReqNotaFinal',
        'mensaje': 'There must be a defined item as a final grade'
    },
    {
        'codigo': 'EvaStrReqRubros',
        'mensaje': 'You must enter at least one defined item as a final grade'
    },
    {
        'codigo': 'ErrorAcademicOfferIdNotEmty',
        'mensaje': 'The data of the academic offer was not found.'
    },
    {
        'codigo': 'ErrorActualizarComentario',
        'mensaje': 'There were problems updating the comment.'
    },
    {
        'codigo': 'ErrorAgregarComentario',
        'mensaje': 'There were problems entering the comment.'
    },
    {
        'codigo': 'ErrorAsignarEstructuraPre',
        'mensaje': 'There were problems assigning the evaluation structure.'
    },
    {
        'codigo': 'ErrorComentarioGestion',
        'mensaje': 'There were problems entering the comment.'
    },
    {
        'codigo': 'ErrorCommentNotEmpty',
        'mensaje': 'You must enter the comment.'
    },
    {
        'codigo': 'ErrorCrearEstructuraEval',
        'mensaje': 'There were problems creating the evaluation structure.'
    },
    {
        'codigo': 'ErrorCrearSolGestion',
        'mensaje': 'There were problems creating the request.'
    },
    {
        'codigo': 'ErrorCustomerIdNotEmpty',
        'mensaje': 'The CIF data could not be found.'
    },
    {
        'codigo': 'ErrorDetalleEstructura',
        'mensaje': 'Problems arose when obtaining the detail of the evaluation structure.'
    },
    {
        'codigo': 'ErrorDetalleGestion',
        'mensaje': 'There were problems obtaining the detail of the request.'
    },
    {
        'codigo': 'ErrorEvaluationStructureIdNotEmpty',
        'mensaje': 'No evaluation structure data found.'
    },
    {
        'codigo': 'ErrorListadoGestionEstudiante',
        'mensaje': 'There were problems getting the list of requests.'
    },
    {
        'codigo': 'ErrorListEstructuras',
        'mensaje': 'There were problems getting the list of evaluation structures.'
    },
    {
        'codigo': 'ErrorReqRequestIdNotEmty',
        'mensaje': 'There were problems getting the request data.'
    },
    {
        'codigo': 'ErrorRequestIdNotEmpty',
        'mensaje': 'There were problems getting the request data.'
    },
    {
        'codigo': 'ErrorResumenGestiones',
        'mensaje': 'There were problems getting the summary of the requests.'
    },
    {
        'codigo': 'ErrorTypeNotEmty',
        'mensaje': 'You must select the type of record.'
    },
    {
        'codigo': 'ErrorDuplicateRequisitoCurso',
        'mensaje': 'The selected course is already a requirement.'
    },
    {
        'codigo': 'ErrorAcademicGradeNotEmpty',
        'mensaje': 'You must select the academic degree.'
    },
    {
        'codigo': 'ErrorCourseReqIdNotEmpty',
        'mensaje': 'You must select the course requirement'
    },
    {
        'codigo': 'ErrorRequiredCourseIdNotEmpty',
        'mensaje': 'You must select the course requirement.'
    },
    {
        'codigo': 'ErrorOriginCourseIdNotEmpty',
        'mensaje': 'You must select the origin course.'
    },
    {
        'codigo': 'ErrorFileFormatIdNotEmpty',
        'mensaje': 'File format data not found.'
    },
    {
        'codigo': 'ErrorGradeIdNotEmty',
        'mensaje': 'You must select the grade.'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'File format (extension) not allowed.'
    },
    {
        'codigo': 'ErrorValidatingComment',
        'mensaje': 'You must enter a comment.'
    },
    {
        'codigo': 'ErrorValidatingState',
        'mensaje': 'You must select a state.'
    },
    {
        'codigo': 'CodeRequeridoCredito',
        'mensaje': 'You must enter the number of credits.'
    },
    {
        'codigo': 'CodeRequeridoBloque',
        'mensaje': 'You must enter the block number.'
    },
    {
        'codigo': 'CodeRequeridoSequencia',
        'mensaje': 'You must enter the sequence.'
    },
    //CAMPOS OBLIGATORIOS
    {
        'codigo': 'ErrorAddressTypeIdNotEmty',
        'mensaje': 'You must select the type of address.'
    },
    {
        'codigo': 'ErrorCodLanIdNotEmty',
        'mensaje': 'You must select the language.'
    },
    {
        'codigo': 'ErrorContactNameNotEmty',
        'mensaje': 'You must enter the name of the contact.'
    },
    {
        'codigo': 'ErrorContactTypeIdNotEmty',
        'mensaje': 'You must select the type of phone.'
    },
    {
        'codigo': 'ErrorCountryCodeNotEmty',
        'mensaje': 'You must enter the country code.'
    },
    {
        'codigo': 'ErrorCountryIdNotEmty',
        'mensaje': 'You must select the country.'
    },
    {
        'codigo': 'ErrorCourseIdNotEmty',
        'mensaje': 'You must select the course.'
    },
    {
        'codigo': 'ErrorCuaPostalCodeNotEmty',
        'mensaje': 'You must enter the zip code.'
    },
    {
        'codigo': 'ErrorCusBirthDateNotEmty',
        'mensaje': 'You must enter the date of birth.'
    },
    {
        'codigo': 'ErrorCusCivilStsNotEmty',
        'mensaje': 'You must select the marital status.'
    },
    {
        'codigo': 'ErrorCusGenderNotEmty',
        'mensaje': 'You must select the gender.'
    },
    {
        'codigo': 'ErrorCusIdeNotEmty',
        'mensaje': 'You must enter the ID.'
    },
    {
        'codigo': 'ErrorCusLastName1NotEmty',
        'mensaje': 'You must enter the first last name.'
    },
    {
        'codigo': 'ErrorCusLastName2NotEmty',
        'mensaje': 'You must enter the second last name.'
    },
    {
        'codigo': 'ErrorCusNameNotEmty',
        'mensaje': 'You must enter the name.'
    },
    {
        'codigo': 'ErrorCusOtherIdeNotEmty',
        'mensaje': 'You must enter the CIF number.'
    },
    {
        'codigo': 'ErrorCusTypeIdeNotEmty',
        'mensaje': 'You must select the type of identification.'
    },
    {
        'codigo': 'ErrorDirectionNotEmty',
        'mensaje': 'You must enter the address.'
    },
    {
        'codigo': 'ErrorEmailNotEmty',
        'mensaje': 'You must enter an email.'
    },
    {
        'codigo': 'ErrorEmailTypeIdNotEmty',
        'mensaje': 'You must select the type of email.'
    },
    {
        'codigo': 'ErrorJobsIdNotEmty',
        'mensaje': 'You must select the job.'
    },
    {
        'codigo': 'ErrorLanLevelIdNotEmty',
        'mensaje': 'You must select a language level.'
    },
    {
        'codigo': 'ErrorObservationNotEmty',
        'mensaje': 'You must enter an observation/comment.'
    },
    {
        'codigo': 'ErrorPhoneNotEmty',
        'mensaje': 'You must enter the phone number.'
    },
    {
        'codigo': 'ErrorProvinceNotEmty',
        'mensaje': 'You must select the location.'
    },
    {
        'codigo': 'ErrorStartDateNotEmty',
        'mensaje': 'You must enter the start date.'
    },
    {
        'codigo': 'ErrorStateCourseIdNotEmty',
        'mensaje': 'You must select a course status.'
    },
    {
        'codigo': 'ErrorTipoCIFNotEmty',
        'mensaje': 'You must select a type of CIF.'
    },
    {
        'codigo': 'ErrorTypeCourseIdNotEmty',
        'mensaje': 'You must select a course type.'
    },
    {
        'codigo': 'ErrorTypeNacionalidadNotEmty',
        'mensaje': 'You must select the type of nationality.'
    },
    {
        'codigo': 'ErrorUbication2IdNotEmty',
        'mensaje': 'You must select the location.'
    },
    {
        'codigo': 'ErrorUbication3IdNotEmty',
        'mensaje': 'You must select the location.'
    },
    {
        'codigo': 'ErrorUbication4IdNotEmty',
        'mensaje': 'You must select the location.'
    },
    {
        'codigo': 'ErrorWorkplaceIdNotEmty',
        'mensaje': 'You must select the workplace.'
    },
    {
        'codigo': 'ProgramRelCourseIdNotEmty',
        'mensaje': 'You must select the course.'
    },
    {
        'codigo': 'InstitutionsOriginIdNotEmty',
        'mensaje': 'You must select the home institution.'
    },
    {
        'codigo': 'MadeByNotEmty',
        'mensaje': 'You must enter who approved the validation.'
    },
    {
        'codigo': 'ScoreNotEmty',
        'mensaje': "You must enter the student's note."
    },
    //FIN CAMPOS OBLIGATORIOS
    {
        'codigo': 'ErrorEventDateNotEmty',
        'mensaje': 'You must enter the date of the event.'
    },
    {
        'codigo': 'ErrorTitleNotEmty',
        'mensaje': 'Title is required.'
    },
    {
        'codigo': 'ErrorStartTimeNotEmty',
        'mensaje': 'You must enter the start time.'
    },
    {
        'codigo': 'ErrorEndTimeNotEmty',
        'mensaje': 'You must enter the end time.'
    },
    {
        'codigo': 'ErrorActualizarCeremonia',
        'mensaje': 'There were problems updating the ceremony.'
    },
    {
        'codigo': 'ErrorActualizarCursoConvalidados',
        'mensaje': 'Problems arose when updating the course to be recognized.'
    },
    {
        'codigo': 'ErrorAdmisionDestinationIdNotEmpty',
        'mensaje': 'You must select the destination program.'
    },
    {
        'codigo': 'ErrorAdmisionOriginIdNotEmpty',
        'mensaje': 'You must select the source program.'
    },
    {
        'codigo': 'ErrorCeremonyIdNotEmpty',
        'mensaje': 'The details of the ceremony were not found.'
    },
    {
        'codigo': 'ErrorCommentsNotEmpty',
        'mensaje': 'You must enter a comment.'
    },
    {
        'codigo': 'ErrorCrearCeremonia',
        'mensaje': 'There were problems registering the ceremony.'
    },
    {
        'codigo': 'ErrorCrearCursoConvalidados',
        'mensaje': 'Problems arose when entering the course to be recognized.'
    },
    {
        'codigo': 'ErrorCstIdNotEmpty',
        'mensaje': "The student's data was not found within the ceremony."
    },
    {
        'codigo': 'ErrorDateAndtimeNotEmpty',
        'mensaje': 'You must enter the date and time.'
    },
    {
        'codigo': 'ErrorEliminarCeremonia',
        'mensaje': 'Problems arose when removing the ceremony.'
    },
    {
        'codigo': 'ErrorEliminarCursoConvalidados',
        'mensaje': 'Problems arose when deleting the course to be recognized.'
    },
    {
        'codigo': 'ErrorEliminarEstudianteCeremonia',
        'mensaje': 'Problems arose removing the student from the ceremony.'
    },
    {
        'codigo': 'ErrorFolioNotEmpty',
        'mensaje': 'Folio is required.'
    },
    {
        'codigo': 'ErrorInscribirEstudiantesCeremonia',
        'mensaje': 'There were problems registering the student for the ceremony.'
    },
    {
        'codigo': 'ErrorInstitutionsOriginIdNotEmpty',
        'mensaje': 'The home institution is required.'
    },
    {
        'codigo': 'ErrorListAcaProgramCourseDetails',
        'mensaje': 'There were problems getting the list of courses for the program.'
    },
    {
        'codigo': 'ErrorListaCeremonia',
        'mensaje': 'There were problems getting the list of ceremonies.'
    },
    {
        'codigo': 'ErrorListaCursosConvalidar',
        'mensaje': 'Problems arose when obtaining the list of courses to validate.'
    },
    {
        'codigo': 'ErrorListaEstudianteCeremonia',
        'mensaje': 'Problems arose in obtaining the list of students enrolled in the ceremony.'
    },
    {
        'codigo': 'ErrorListCoursesHomologate',
        'mensaje': 'Problems arose when obtaining the list of recognized courses.'
    },
    {
        'codigo': 'ErrorMadeByNotEmpty',
        'mensaje': 'You must enter the name of the responsible person.'
    },
    {
        'codigo': 'ErrorObtenerCeremonia',
        'mensaje': 'There were problems obtaining the data of the ceremony.'
    },
    {
        'codigo': 'ErrorObtenerCursoConvalidado',
        'mensaje': 'Problems arose when obtaining data from the recognized course.'
    },
    {
        'codigo': 'ErrorProgramRelCourseIdNotEmty',
        'mensaje': 'You must select a course.'
    },
    {
        'codigo': 'ErrorRcoIdNotEmpty',
        'mensaje': 'The data of the recognized course were not found.'
    },
    {
        'codigo': 'ErrorRecognitionDateNotEmpty',
        'mensaje': 'You must enter the validation date.'
    },
    {
        'codigo': 'ErrorScoreNotEmpty',
        'mensaje': 'You must enter a score.'
    },
    {
        'codigo': 'ErrorSeatNotEmpty',
        'mensaje': 'The seat is required.'
    },
    {
        'codigo': 'ErrorSpaceAvailableNotEmpty',
        'mensaje': 'You must specify the number of available fields.'
    },
    {
        'codigo': 'ErrorUpdateHomologateCurses',
        'mensaje': 'Problems arose when updating the homologation data.'
    },
    {
        'codigo': 'ErrorUpdateHomologateCursesStudents',
        'mensaje': "Problems arose when homologating the student's courses."
    },
    {
        'codigo': 'ErrorValidatingCoursesHomologate',
        'mensaje': 'Problems arose when validating the homologation data.'
    },
    {
        'codigo': 'ErrorVolumeNotEmpty',
        'mensaje': 'The volume is required.'
    },
    {
        'codigo': 'ErrorValidarConclusion',
        'mensaje': 'Problems arose when validating the conclusion of the academic program.'
    },
    {
        'codigo': 'ErrorGetInstrPrincipalAcaOffer',
        'mensaje': 'There were problems getting a lead instructor.'
    },
    {
        'codigo': 'ErrorAcaOffSchedulesReq',
        'mensaje': 'It is required to enter a schedule.'
    },
    {
        'codigo': 'ErrorAcaOffClassroomReq',
        'mensaje': 'It is required to enter a classroom for each schedule.'
    },
    {
        'codigo': 'ErrorAcaOffInstructorReq',
        'mensaje': 'It is required to enter at least one instructor per schedule.'
    },
    {
        'codigo': 'ErrHomoCourseDuplicate',
        'mensaje': 'The course is duplicated.'
    },
    {
        'codigo': 'ErrHomoCourseSameProgram',
        'mensaje': 'The course cannot belong to the same academic program.'
    },
    {
        'codigo': 'ErrInternalPeriodNotFound',
        'mensaje': 'No academic period was found to carry out the process.'
    },
    {
        'codigo': 'ErrorHomologationStudentCourses',
        'mensaje': 'Problems arose when carrying out the process of homologation of courses.'
    },
    {
        'codigo': 'ErrGradCerAdmissionExists',
        'mensaje': 'The student is already registered for the graduation ceremony with the selected program.'
    },
    {
        'codigo': 'ErrGradCerExpired',
        'mensaje': 'The graduation ceremony is over.'
    },
    {
        'codigo': 'ErrGradCerFullQuota',
        'mensaje': 'There are no fields available to include more students.'
    },
    {
        'codigo': 'ErrGradCerAddStudent',
        'mensaje': 'Problems arose in including the student to the graduation ceremony.'
    },
    {
        'codigo': 'ErrorInsertRecognitionCourse',
        'mensaje': 'Problems arose when including the course to be recognized.'
    },
    {
        'codigo': 'ErrorUpdateRecognitionCourse',
        'mensaje': 'Problems arose when updating the course to be recognized.'
    },
    {
        'codigo': 'ErrorDeleteRecognitionCourse',
        'mensaje': 'Problems arose when deleting the course to be recognized.'
    },
    {
        'codigo': 'ErrProgramStudentIncomplete',
        'mensaje': 'The student has not yet completed the study plan of the academic program.'
    },
    {
        'codigo': 'ErrRangoHora',
        'mensaje': 'The end time must be greater than the start time.'
    },
    {
        'codigo': 'ErrorQualifyScoreNotAllowed',
        'mensaje': 'The teacher does not have permissions to grade the student.'
    },
    {
        'codigo': 'ErrorRangeQualifyScore',
        'mensaje': 'The entered grade is outside the allowed range.'
    },
    {
        'codigo': 'ErrorGradeStudentItemUpdate',
        'mensaje': 'There were problems updating the grade.'
    },
    {
        'codigo': 'ErrorEnrollAcaOffer',
        'mensaje': 'There were problems registering the course.'
    },
    {
        'codigo': 'ErrorUNEnrollAcaOffer',
        'mensaje': 'Problems arose when un-enrolling the course.'
    },
    {
        'codigo': 'ErrorUnRollMandatoryCourse',
        'mensaje': 'You must first unenroll non-required courses.'
    },
    {
        'codigo': 'ErrorMandatoryBlockCourses',
        'mensaje': 'You must first enroll in the compulsory courses.'
    },
    {
        'codigo': 'ErrorAdmRequirementBlock',
        'mensaje': 'You have pending requirements for admission to the academic block of the selected course.'
    },
    {
        'codigo': 'DuplicateCustomerCountry',
        'mensaje': 'The customer already has a registration with that nationality.'
    },
    {
        'codigo': 'ErrorExistsCustomerLanguaje',
        'mensaje': 'There is already a record with this language.'
    },
    {
        'codigo': 'CodeRequeridoComentario',
        'mensaje': 'You must enter a comment.'
    }
];